/* eslint-disable @typescript-eslint/ban-ts-comment */
import Image from "next/image";
import React from "react";

import theme from "@/styles/themes/theme";
import { documentToReactComponents, Options } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import { Button, Divider, Stack, Typography } from "@mui/material";

import { styles } from "./styles";
import { CardTag } from "@/components/Card/CardTag";
import { PartnerConfigInformative } from "@/services/contentful/categories";

const options: Options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      // @ts-ignore
      const isBlankLine = /^\s*$/.test(children?.join(""));

      if (isBlankLine) {
        return <br />;
      }

      return <p>{children}</p>;
    }
  }
};

export const ContainerInformativo: React.FC<{ informative: PartnerConfigInformative }> = ({ informative }) => {
  if (!informative) {
    return null;
  }

  const { title, buttonTitle, buttonURL, information, backgroundImage, firstTagTitle, firstTagDescription, secondTagTitle, secondTagDescription } =
    informative;

  return (
    <Stack
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center"
      }}
    >
      <Stack css={styles.inforimage} sx={{ width: "100%", height: "auto" }}>
        <Image src={backgroundImage} alt={title} width={1440} height={306} css={styles.image} />
      </Stack>

      <Typography css={styles.informsg}>{title}</Typography>

      <Stack css={styles.inforlist}>
        <Button variant="contained" href={buttonURL} target="_blank" sx={{ color: theme.palette.common.black, width: 300, textAlign: "center" }}>
          {buttonTitle}
        </Button>

        <Divider orientation="vertical" flexItem css={styles.infordivider} />

        <Typography component="div" css={{ color: theme.palette.grey[800], width: "350px" }}>
          {documentToReactComponents(information, options)}
        </Typography>
      </Stack>

      <Stack
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "3rem",
          gap: "1rem"
        }}
      >
        {firstTagTitle && <CardTag title={firstTagTitle} description={firstTagDescription} />}
        {secondTagTitle && <CardTag title={secondTagTitle} description={secondTagDescription} />}
      </Stack>
    </Stack>
  );
};
